import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "d-flex mb-6" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "mb-0" }, "Schedule Settings", -1)
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-12" }
const _hoisted_5 = { class: "nav nav-tabs gap-4 gap-lg-10 gap-xl-15" }
const _hoisted_6 = { class: "col-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_VenueSettings = _resolveComponent("VenueSettings")!
  const _component_CallTypeSettings = _resolveComponent("CallTypeSettings")!
  const _component_ModalBase = _resolveComponent("ModalBase")!

  return (_openBlock(), _createBlock(_component_ModalBase, {
    ref: "modal",
    size: "modal-lg",
    title: "",
    "has-footer": false,
    "has-header": false,
    "has-toolbar": false
  }, {
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createVNode(_component_Button, {
          onClick: _ctx.addVenue,
          class: "ms-auto btn-sm"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Add Venue")
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_Button, {
          onClick: _ctx.addCallType,
          class: "ms-4 btn-sm"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Add Call Type")
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("nav", _hoisted_5, [
            _createElementVNode("div", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.tab = 'venues')),
              class: _normalizeClass(["fs-4 fw-bolder pb-3 cursor-pointer", {'border-bottom border-3 border-primary': _ctx.tab === 'venues'}])
            }, "Venues & Spaces", 2),
            _createElementVNode("div", {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.tab = 'calltypes')),
              class: _normalizeClass(["fs-4 fw-bolder pb-3 cursor-pointer", {'border-bottom border-3 border-primary': _ctx.tab === 'calltypes'}])
            }, "Call Types", 2)
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          (_ctx.tab === 'venues')
            ? (_openBlock(), _createBlock(_component_VenueSettings, { key: 0 }))
            : _createCommentVNode("", true),
          (_ctx.tab === 'calltypes')
            ? (_openBlock(), _createBlock(_component_CallTypeSettings, { key: 1 }))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _: 1
  }, 512))
}